var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[_c('sale-form',{attrs:{"model":_vm.model,"titlePrefix":_vm.$t('forms.title_prefix.add')},on:{"saved":_vm.saved}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }